// GRANT_TYPES of GRANT_CRITERIA
import { getThanksOnlyPointName } from "@/common/assets/js/utils/pointName";

const LABEL_10 = (gc: boolean) => (gc ? "制限なし" : "通常");

const LABEL_30 = "サンクス専用";
const LABEL_40 = "付与専用";

const LABELS: { [key: number]: any } = {
  30: LABEL_30,
  40: LABEL_40
};

export function getTypeSortLabel(gc: boolean, keys: Array<number>) {
  const labels = [];

  if (keys.includes(10)) {
    labels.push({
      id: "type-is-default",
      value: 10,
      label: LABEL_10(gc)
    });
  }
  if (keys.includes(30)) {
    labels.push({
      id: "type-is-thanks",
      value: 30,
      label: getThanksOnlyPointName(LABEL_30)
    });
  }
  if (keys.includes(40)) {
    labels.push({
      id: "type-is-grant",
      value: 40,
      label: LABEL_40
    });
  }

  return labels;
}

export function getTypeLabel(type: number, gc: boolean) {
  if (type === 30) {
    return getThanksOnlyPointName(LABEL_30);
  }
  return type === 10 ? LABEL_10(gc) : LABELS[type];
}

export function getThanksOrGrantTypeLabel(type: number) {
  if (type === 30) {
    return getThanksOnlyPointName(LABEL_30);
  } else if (type === 40) {
    return LABELS[type];
  }
  return null;
}

export function getApprovalStatusLabel(status: string) {
  let approvalBagged = "";
  if (status == "pending") {
    approvalBagged = "未承認";
  } else if (status == "approved") {
    approvalBagged = "承認済み";
  }
  return approvalBagged;
}
